import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram, Phone } from 'lucide-react';

const Footer = () => {
  const footerSections = [
    {
      title: 'Services',
      links: [
        { label: 'Influencer Marketing', href: '#services' },
        { label: 'Talent Management', href: '#services' },
        { label: 'PR', href: '#services' },
        { label: 'Performance Marketing', href: '#services' }
      ]
    },
    {
      title: 'Quick Links',
      links: [
        { label: 'Services', href: '#services' },
        { label: 'Why Us', href: '#why-us' },
        { label: 'Contact Us', href: '#contact' },
        { label: 'FAQs', href: '#faq' }
      ]
    },
    {
      title: 'Connect',
      links: [
        { label: 'LinkedIn', href: '#' },
        { label: 'Instagram', href: '#' },
        { label: 'Phone', href: 'tel:+918287836426' },
        { label: 'Email', href: 'mailto:collab@lxdia.com' }
      ]
    }
  ];

  return (
    <footer className="bg-white text-gray-800 py-16 px-6">
      <div className="mx-auto max-w-7xl">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <h3 className="text-2xl font-bold mb-6 font-mosans">lxdia</h3>
            <div className="space-y-4 text-sm font-inter">
              <div>
                <p className="font-semibold mb-1">Delhi, India</p>
                <p className="text-gray-600">
                  Your Growth Partner for<br />
                  Digital Success
                </p>
              </div>
              <div>
                <p className="text-gray-600">
                  <a href="mailto:collab@lxdia.com" className="hover:text-black transition-colors">
                    collab@lxdia.com
                  </a>
                </p>
              </div>
            </div>
            {/* Social Links */}
            <div className="flex gap-4 mt-6">
              <a
                href="#"
                className="w-10 h-10 bg-black rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors"
              >
                <Linkedin className="w-5 h-5 text-white" />
              </a>
              <a
                href="https://www.instagram.com/lxdia.connect/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-black rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors"
              >
                <Instagram className="w-5 h-5 text-white" />
              </a>
            </div>
          </div>

          {/* Footer Links */}
          {footerSections.map((section, index) => (
            <div key={index}>
              <h4 className="font-bold mb-4 text-sm">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a
                      href={link.href}
                      className="text-sm text-gray-600 hover:text-black transition-colors inline-flex items-center gap-2"
                    >
                      {link.label}
                      {link.badge && (
                        <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                          {link.badge}
                        </span>
                      )}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-600 font-inter">
              © 2025 Lxdia. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center gap-6 text-sm font-inter">
              <Link to="/terms" className="text-gray-600 hover:text-black transition-colors">
                Terms & Service
              </Link>
              <Link to="/privacy" className="text-gray-600 hover:text-black transition-colors">
                Privacy Policy
              </Link>
              <Link to="/cookies" className="text-gray-600 hover:text-black transition-colors">
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
